import React from "react";
import { HERO_IMAGES, HERO_CAPTIONS } from "../data/content";

// Fallback nature/herbal images (in case Wayback originals are blocked)
const FALLBACK = [
  "https://images.unsplash.com/photo-1543362906-acfc16c67564?auto=format&fit=crop&w=1400&q=70",
  "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=1400&q=70",
  "https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?auto=format&fit=crop&w=1400&q=70",
  "https://images.unsplash.com/photo-1499728603263-13726abce5fd?auto=format&fit=crop&w=1400&q=70",
  "https://images.unsplash.com/photo-1505672984371-f25dcf94b9f5?auto=format&fit=crop&w=1400&q=70",
  "https://images.unsplash.com/photo-1466637574441-749b8f19452f?auto=format&fit=crop&w=1400&q=70",
];

export default function HeroSlideshow() {
  const total = HERO_IMAGES.length;
  return (
    <div className="relative w-full h-[420px] md:h-[480px] overflow-hidden bg-[#3b2a1e]">
      {HERO_IMAGES.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={HERO_CAPTIONS[i]}
          className="nn-slide"
          style={{ animationDelay: `${(36 / total) * i}s` }}
          onError={(e) => {
            if (e.currentTarget.dataset.fb !== "1") {
              e.currentTarget.dataset.fb = "1";
              e.currentTarget.src = FALLBACK[i % FALLBACK.length];
            }
          }}
        />
      ))}
      {/* Caption */}
      <div className="absolute inset-0 flex items-center justify-start pointer-events-none">
        <h2
          className="font-display italic text-white/95 text-3xl md:text-5xl pl-6 md:pl-12 drop-shadow-[0_2px_4px_rgba(0,0,0,0.6)]"
          style={{ textShadow: "0 2px 8px rgba(0,0,0,0.55)" }}
        >
          ancient wisdom
        </h2>
      </div>
    </div>
  );
}
